<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="home room room-detail">
      <div class="room-detail_inner">
        <div class="room-detail_item">
          <p class="room-detail_title">ルーム名</p>
          <div class="room-name_box">
            <input type="text" class="room-name" v-model="formData.name">
            <button class="room-remove-btn" @click="clearName">
              <img src="@/assets/img/room/icon_close.png" alt="">
            </button>
          </div>
        </div>
        <div class="room-detail_item">
          <p class="room-detail_title">一般ユーザ</p>
          <p class="user-name-top" @click="showChoose" >{{ chooseName }}</p>
        </div>
        <p :class="[this.formData.name && this.chooseName ?'change':'']" id="change_btn" @click="handleSure">変更する</p>
      </div>
    </div>
    <div v-if="showType" class="popup-bg">
      <div class="popup">
        <div class="btn">
          <div @click="cancel" class="cancle">キャンセル</div>
          <div @click="confirm" class="confirm">確認</div>
        </div>
        <van-cell clickable title="すべて選択" @click="selectAll()">
          <template #right-icon>
            <van-checkbox
                shape="square"
                v-model="selectAllFlg"
                @click.stop="selectAll(true)"
            />
          </template>
        </van-cell>
        <van-cell
            v-for="(item, index) in doctorColums"
            clickable
            :key="index"
            :title="item.name"
            @click="selectItem(item)"
        >
          <template #right-icon>
            <van-checkbox
                shape="square"
                v-model="item.selected"
                @click.stop="selectItem(item,true)"
            />
          </template>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { FindSameTeamDoctors } from "@/services/team";
import { GetRoomDetail, SaveRoom } from "@/services/room";
import { Toast } from "vant";
import "vant/es/toast/style";
import Header from "@/components/Header.vue";
import _ from 'lodash';

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      formData: {},
      doctorColums: [],
      showType: false,
      chooseName: "",
      chooseId: [],
      backChoose:[],
      selectAllFlg:false,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.room_id = this.$route.query.room_id;
    this.formData.id = this.$route.query.id;
    this.formData.room_id = this.$route.query.room_id;
    this.initDoctorList();
  },
  methods: {
    selectAll(isCheckBox){
      if(!isCheckBox){
        this.selectAllFlg = !this.selectAllFlg;
      }
      this.doctorColums.forEach((item)=>{
        item.selected = this.selectAllFlg;
      });
    },
    selectItem(item,isCheckBox){
      if(!isCheckBox){
        item.selected = !item.selected;
      }
      this.setChooseName();
    },
    setChooseName(){
      let chooseName = "";
      let chooseId = [];
      let selectAllFlg = true;
      this.doctorColums.forEach((item)=>{
        if(item.selected && chooseName ==''){
          chooseName = item.name;
          chooseId.push(item.doctor_id)
        }else if(item.selected && chooseName !==''){
          chooseName += ","+ item.name;
          chooseId.push(item.doctor_id)
        }else{
          selectAllFlg = false;
        }
      });
      this.chooseName = chooseName;
      this.chooseId = chooseId;
      this.selectAllFlg = selectAllFlg;
    },
    clearName(){
      this.formData.name = "";
    },
    initRoomDetail() {
      const room_id = this.room_id;
      GetRoomDetail(room_id).then((res) => {
        const roomInfo = res.data.data.detail;
        if (roomInfo) {
          this.formData.name = roomInfo.name;
          if (roomInfo.join_doctor_ids) {
            let join_doctor_list = roomInfo.join_doctor_ids.split(",");
            for(let i=0;i<join_doctor_list.length;i++){
              for(let j=0;j<this.doctorColums.length;j++){
                if(join_doctor_list[i] == this.doctorColums[j].doctor_id){
                  this.doctorColums[j].selected = true;
                  break;
                }
              }
            }
            this.setChooseName();
          }
        }
      });
    },
    initDoctorList() {
      FindSameTeamDoctors().then((res) => {
        this.doctorColums = res.data.data || [];
        this.initRoomDetail();
      });
    },
    onClickLeft() {
      history.back();
    },
    showChoose() {
      this.showType = true;
      // 深拷贝
      this.backChoose = _.cloneDeep(this.doctorColums);
    },
    confirm() {
      this.showType = false;
      this.setChooseName();
    },
    cancel() {
      this.showType = false;
      this.doctorColums = _.cloneDeep(this.backChoose);
    },
    handleSure() {
      this.formData.all_doctor = 0;
      this.formData.type = "app";
      this.formData.join_doctor_ids = this.chooseId.join(',');
      SaveRoom({
        detail: this.formData,
      }).then((res) => {
        if (res.data.code >= 0) {
          Toast.success("変更に成功しました。");
          history.back();
        } else {
          Toast.fail("変更に失敗しました。");
        }
      });
    },
  },
};
</script>

<style scoped>
   
   
  
.popup-bg {
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
.btn {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: white;
}
.cancle {
  padding: 15px 0px 15px 18px;
  font-size: 18px;
  font-weight: bold;
}
.confirm {
  padding: 15px 18px 15px 0px;
  font-size: 18px;
  font-weight: bold;
}
.popup {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 400px;
  overflow: auto;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: #fff;
}
</style>
